import { Grid2, Stack } from '@mui/material'
import React from 'react'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialInput from '../../../components/MaterialInput'
import MaterialSelect from '../../../components/MaterialSelect'

const NomineeDetails = ({ basicDetails }) => {
    return (
        <Grid2 container spacing={3} sx={{ padding: '10px' }}>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Nominee Name<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        fullWidth
                        label="Nominee Name"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={basicDetails.nomineeName}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Nominee RelationShip<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialSelect
                        label="Relation"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={basicDetails.nomineeRelation}
                        options={['Father', 'Mother', 'Spouse', 'Child', 'Sibling']}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Nominee DOB<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        fullWidth
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        label="Nominee DOB"
                        variant="outlined"
                        value={basicDetails.nomineeDob}
                    />
                </Stack>
            </Grid2>
        </Grid2>
    )
}

export default NomineeDetails
